<template>
  <v-dialog name="asd" v-model="modalComputed" persistent  max-width="780" v-if="produtoComputed !== undefined">
    <v-card>

      <v-toolbar flat color="accent">
        <v-btn icon @click="modalComputed = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title name="654">Pre&ccedil;os - Produto {{ this.produtoComputed.cc_psr }}, {{ this.produtoComputed.nm_psr }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">

              <div v-if="itens.length === 0">
                <v-alert text type="info" color="primary">N&atilde;o h&aacute; pre&ccedil;os cadastrados para este produto</v-alert>
              </div>

              <v-simple-table class="mb-2" v-else>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="30">Tabela</th>
                      <th>Valor</th>
                      <th width="30"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itens" :key="item.id_reg">
                      <td>{{ item.cc_pre }}</td>
                      <td>{{ moeda(item.vl_pre) }}</td>
                      <td>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                              <v-btn depressed small fab color="primary" v-on="on" @click="deletar(item)">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                          </template>
                          <span>Deletar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-card outlined>
                <v-card-text>
                  <v-form ref="form" @submit="inserir()" v-model="valid" :lazy-validation="lazy" v-on:submit.prevent>
                      <div class="d-flex flex-row mb-6">
                        <v-select v-model="preco.cc_pre" label="Tabela" :items="tabela" item-text="cc_pre" item-value="cc_pre" class="mr-2" :rules="validacao.cc_pre"></v-select>
                        <v-text-field v-model="preco.vl_pre" type="number" label="Valor" :rules="validacao.vl_pre"></v-text-field>
                      </div>
                      <v-btn depressed outlined type="submit" color="primary">SALVAR</v-btn>
                  </v-form>
                </v-card-text>
              </v-card>

            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>
<script>
import { moeda } from '../../utils.js'
export default {

  name: 'Preco',

  data() {
    return {

      valid: true,
      lazy:true,
      itens:[],

      tabela:[{cc_pre: 'V1'}],

      preco: {
        cc_psr: undefined,
        cc_fil: undefined,
        cc_pre: undefined,
        vl_pre: undefined,
        qt_pre_ini: 0.00,
        qt_pre_fim: 999999999.99,
      },

      validacao: {
        cc_pre: [
          (v) => !!v || 'Requerido',
        ],
        vl_pre: [
          (v) => !!v || 'Requerido',
          //(v) => /^[0-9]*[.][0-9]+$/.test(v) || 'Formato inválido'
          (v) => { if(v === undefined || v < 0) {return 'Requerido'} else { return true } }
        ]
      },

      produtoTemp: undefined,
      modalTemp: undefined
    }
  },

  props: {

    produto: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  methods: {

    listar() {
      this.itens = []
      if(this.produtoComputed !== undefined) {
        this.$store.dispatch('pesquisaPreco', {size:9999, cc_fil: this.produtoComputed.cc_fil, cc_psr: this.produtoComputed.cc_psr}).then(resp => {
           resp.data.content.forEach(el => {
             this.itens.push(el)
           });
         }).catch()
      }
    },

    inserir() {
      if (this.$refs.form.validate()) {
        this.preco.cc_fil = this.produtoComputed.cc_fil
        this.preco.cc_psr = this.produtoComputed.cc_psr
        this.$store.dispatch('salvarPreco', this.preco).then(() => {
          this.listar()
          this.resetarFormulario()
        }).catch()
      }
    },

    deletar(item) {
      this.$store.dispatch('deletarPreco', item.id_reg).then(() => {
        this.listar()
      }).catch()
    },

    resetarFormulario(){
      this.$refs.form.reset()
    },

    moeda(valor){
      return moeda(valor)
    }
  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    produtoComputed: {
      get: function() { 
        return this.produtoTemp
      },
      set: function(value) {
        this.produtoTemp = value
      }
    }
  },

  mounted: function() {
    this.listar()
  },

  created: function() {

    this.modalComputed = this.modal
    this.produtoComputed = this.produto
    this.$emit('a')

  }

}
</script>